import React from "react";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import arrowleft from "../../../../assets/img/icons/arrow-left.svg";
import arrowright from "../../../../assets/img/icons/arrow-right.png";
import trash from "../../../../assets/img/icons/trash.svg"
import weekends from "react-multi-date-picker/plugins/highlight_weekends"
import UseWindowSize from "../../../../Sizes/UseWindowSize";

const ChooseSecDateModal = ({ closeModal,className, selectedDay, setSelectedDay }) => {
  const windowSize = UseWindowSize()
  return (
    <div className="ModalBackground" onClick={closeModal}>
      <div className="ChooseDate2month datebox" onClick={(e)=>e.stopPropagation()}>
        <div className="flex justify-between items-center ChooseDate2month--header">
          <div>
            <h4>انتخاب تاریخ سفر</h4>
            <p>برای مشاهده‌ی قیمت، تاریخ ورود ‍و خروج خود را انتخاب کنید</p>
          </div>
          <button  onClick={()=>setSelectedDay(null)}  className="ChooseDate2month--header-button">
            <img src={trash}/>
            <div>
            پاک کردن تاریخ سفر
            </div>
             
          </button>
        </div>
        <Calendar
          value={selectedDay}
          onChange={setSelectedDay}
          showOtherDays
          calendar={persian}
          weekStartDayIndex={1}
          locale={persian_fa}
          disableYearPicker
          plugins={[weekends()]}
          numberOfMonths={windowSize === "sm" || windowSize === "md" || windowSize <"lg" ? 1 : 2} // Set numberOfMonths to 2
          mapDays={({ date }) => {
            let props = {};
            let isWeekend = [6].includes(date.weekDay.index);

            if (isWeekend) props.className = "weekend-red";

            return props;
          }}
          renderButton={(direction, handleClick) =>
            <button className="arrow-button" onClick={handleClick}>
              {direction === "left"
                ? <img src={arrowright} />
                : <img src={arrowleft} />}
            </button>}
        />
      </div>
    </div>
  );
};

export default ChooseSecDateModal;
